<template>
  <main id="home">
    <hero/>
    <bioform />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import hero from '@/components/hero.vue';
import bioform from '@/components/bioform.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    hero,
    bioform
  },
  methods: {
  },
  mounted() {
  },
};
</script>
